import { defineStore } from "pinia";
import { Store } from "@/common/stores.enum";
import {
    DisplayState,
    PanelType,
    TicketSelectionApplicationData,
    TicketSelectionDisplayModeState
} from "@/domain/ticket-selection";
import { PriceListResponse } from "webshop-api";

export const useTicketSelectionDisplayStateStore = defineStore(Store.TicketSelectionDisplayState, {

    state: (): DisplayState => ({
        mobileViewPort: false,
        modeSelectionState: {
            bestSeat: true,
            seatmap: {
                isSeatmapVisible: false,
                isMenuExpanded: false,
            },
        },
        priceList: null,
        cartAmount: 0,
        configuration: null,
        additionalInformation: null,
        seatmapConfig: undefined,
    }),
    getters: {
        isMobileViewPort(state): boolean {
            return state.mobileViewPort;
        },
        getModeSelectionState(state): TicketSelectionDisplayModeState {
            return state.modeSelectionState;
        },
        getPriceList(state): PriceListResponse | null {
            const priceList = state.priceList as PriceListResponse;
            return priceList ?? null;
        },
        hasSeatmapConfig(state): boolean {
            return !!state.seatmapConfig;
        },
        isSeatmapDisplayed(state): boolean {
            return state.modeSelectionState.seatmap.isSeatmapVisible;
        },
        hasDoubleCurrency(state): boolean {
            if (state.priceList && state.cartAmount > 0) {
                return !!state.configuration
                    && state.configuration.cartCurrency !== state.priceList.currency;
            }

            return false;
        },
        canShowSelection(state): boolean {
            let hasDoubleCurrency: boolean;

            if (state.priceList && state.cartAmount > 0) {
                hasDoubleCurrency = !!state.configuration
                    && state.configuration.cartCurrency !== state.priceList.currency;
            } else {
                hasDoubleCurrency = false;
            }

            return !!state.priceList
                && !!state.priceList.priceLevels
                && !hasDoubleCurrency;
        },
        hasAdditionalInformation(state): boolean {
            const promoter = state.additionalInformation ?
                state.additionalInformation.promoter
                : null;

            return state.additionalInformation && state.additionalInformation.fanTicket.isAvailable
                || (!Array.isArray(promoter) && promoter !== null && promoter.name.length !== 0);
        },
    },
    actions: {
        initializeStore(data: TicketSelectionApplicationData) {
            this.priceList = data.priceList;
            this.seatmapConfig = data.seatmapConfig;
            this.configuration = data.configuration;
            this.cartAmount = data.cartAmount;
            this.additionalInformation = data.additionalInformation;
            this.modeSelectionState = data.displayState;
        },
        isFullScreenSeatmap(data: TicketSelectionApplicationData | undefined): boolean {
            return !!(this.isMobileViewPort
                && this.hasSeatmapConfig
                && this.getModeSelectionState.seatmap
                && this.getPriceList
                && this.getPriceList.priceLevels
                && this.getPriceList.priceLevels.length);
        },
        updateDisplayModeWith(state: TicketSelectionDisplayModeState): void {
            this.modeSelectionState = state;
        },
    }
});
